import { getHost, normalize } from './url';

const domains = [
  /qq\.com$/,
  /qlogo\.cn$/,
  /gtimg\.com$/,
  /gtimg\.cn$/,
  /qpic\.cn$/,
  /sinaimg\.cn$/,
];

function _canSkip(url) {
  const host = getHost(url);
  return domains.filter(v => v.test(host)).length === 0;
}
export function createNormalizer() {
  return function (...args) {
    const url = args[0];
    const useRelative = args[1];
    if (
      (!/^(http:|https:|\/\/)/.test(url) && useRelative !== false)
      || _canSkip(url)
    ) {
      return url;
    }
    // 踩坑：避免离线包场景下，url 使用绝对协议却被转为 file 协议
    // reviewed by: tonicli
    if (!args[2] && !useRelative && !location.protocol.match(/^https?:/)) {
      args[2] = 'https:';
    }
    return normalize(...args);
  };
}

export default {
  createNormalizer,
};
